/* Built In Imports */
import dynamic from 'next/dynamic';
import { useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */

/* Services */
import Footer from '@eternal/Components/Footer';

const ScrollToTop = dynamic(() => import('@components/Utility/ScrollToTop'));
const WithPreview = dynamic(() => import('@components/PreviewMode'));

/**
 * Renders the Layout component.
 *
 * @param {object} children - Child Elements.
 * @returns {ReactElement} Layout component
 */
export default function Layout({ children }) {
  // console.log("THE CHILDREN IS", children)
  const {
    // headerTopMenuData,
    // headerMenuData,
    pageData,
    footerData,
    // footerDetailData,
    language,
    isPreview,
    headerVisible = true,
    page,
    // secondMenuVisible = true,
    // hideTopMenu = false,
  } = children.props;

  const [region, setRegion] = useState(children.props?.region || 'in');
  const [isScrollToTop, setIsScrollToTop] = useState(true);

  // console.log(footerData, 'footerData');
  return (
    <Box className={`lang-${language}`}>
      {/* main content to render */}
      {children}
      {/* Footer section */}
      {footerData && (
        <Box pos="relative" float="left" w="100%">
          <Footer
            region={region}
            language={language}
            footerData={footerData}
            page={page}
            // ipWidgetData={ipWidgetData}
          />
        </Box>
      )}

      {/* Bottom widget */}
      {isPreview && <WithPreview isPreview={isPreview} />}
      {isScrollToTop && <ScrollToTop />}
    </Box>
  );
}
